import { RegistryDefinition } from './registry.types';

/**
 * Реестр счетов (`/core/offers`).
 */
export const OFFERS_REGISTRY: RegistryDefinition = {
    id: 'offers',
    title: 'Счета',
    path: '/offers',
    queryMode: 'hash',
    filters: [
        {
            key: 'search',
            label: 'Поиск',
            description: 'Текст поиска по счетам. Используется вместе с searchByWhat.',
            valueType: 'string',
        },
        {
            key: 'searchByWhat',
            label: 'Поиск',
            description:
                'Критерий поиска: BY_STRING (по тексту), BY_EXTERNAL_ID (по внешнему ID), BY_ID (по ID счёта).',
            valueType: 'enum',
            enumValues: ['BY_STRING', 'BY_EXTERNAL_ID', 'BY_ID'],
        },
        {
            key: 'state',
            label: 'Статус счёта',
            description:
                'Статус счёта: NEW (Получен ответ), PROCESSED (Обработан), READY_FOR_ACCEPT (На согласовании), '
                + 'ACCEPTED_BY_ACCEPTORS (Согласован), PAID (Оплачен), DELETED (Неинтересен), '
                + 'DISACCEPTED (Отклонён), PARTLY_PAID (Частично оплачен).',
            valueType: 'enum',
            enumValues: [
                'NEW',
                'PROCESSED',
                'READY_FOR_ACCEPT',
                'ACCEPTED_BY_ACCEPTORS',
                'PAID',
                'DELETED',
                'DISACCEPTED',
                'PARTLY_PAID',
            ],
        },
        {
            key: 'offerType',
            label: 'Тип счёта',
            description: 'ID типа счёта.',
            valueType: 'id',
        },
        {
            key: 'category',
            label: 'Товарная категория',
            description: 'ID товарной категории.',
            valueType: 'id',
        },
        {
            key: 'currency',
            label: 'Валюта',
            description: 'ID валюты.',
            valueType: 'id',
        },
        {
            key: 'important',
            label: 'Срочность',
            description: 'Срочность счёта: true или false.',
            valueType: 'boolean',
        },
        {
            key: 'offerCreation',
            label: 'Происхождение счёта',
            description:
                'Происхождение счёта: NORMAL_REQUEST, PORTAL_REGISTERED, FROM_BOX.',
            valueType: 'enum',
            enumValues: ['NORMAL_REQUEST', 'PORTAL_REGISTERED', 'FROM_BOX'],
        },
        {
            key: 'paymentNumber',
            label: 'Номер п/п',
            description: 'Номер платёжного поручения.',
            valueType: 'string',
        },
        {
            key: 'providerNumber',
            label: 'Номер счёта поставщика',
            description: 'Номер счёта поставщика.',
            valueType: 'string',
        },
        {
            key: 'documentName',
            label: 'Номер документа к счёту',
            description: 'Номер документа к счёту.',
            valueType: 'string',
        },
        {
            key: 'project',
            label: 'Проект',
            description: 'ID проекта.',
            valueType: 'id',
        },
        {
            key: 'showInactiveProjects',
            label: 'Проект',
            description: 'Показывать неактивные проекты в фильтре (true).',
            valueType: 'boolean',
        },
        {
            key: 'producer',
            label: 'Поставщик',
            description: 'ID поставщика.',
            valueType: 'id',
        },
        {
            key: 'producerInn',
            label: 'Поставщик',
            description: 'ИНН поставщика.',
            valueType: 'string',
        },
        {
            key: 'showCompaniesWithSameITN',
            label: 'Поставщик',
            description: 'Учитывать компании с таким же ИНН у поставщика (true).',
            valueType: 'boolean',
        },
        {
            key: 'payer',
            label: 'Плательщик',
            description: 'ID плательщика.',
            valueType: 'id',
        },
        {
            key: 'payerInn',
            label: 'Плательщик',
            description: 'ИНН плательщика.',
            valueType: 'string',
        },
        {
            key: 'acceptor',
            label: 'Акцептор',
            description: 'ID акцептора.',
            valueType: 'id',
        },
        {
            key: 'creator',
            label: 'Создатель заявки',
            description: 'ID создателя заявки.',
            valueType: 'id',
        },
        {
            key: 'responsible',
            label: 'Ответственный по заявке',
            description: 'ID ответственного по заявке.',
            valueType: 'id',
        },
        {
            key: 'senderToAcceptance',
            label: 'Передал на согласование',
            description: 'ID пользователя, передавшего на согласование.',
            valueType: 'id',
        },
        {
            key: 'operator',
            label: 'Оператор',
            description: 'ID оператора.',
            valueType: 'id',
        },
        {
            key: 'orderId',
            label: 'ID заявки',
            description: 'ID связанной заявки.',
            valueType: 'id',
        },
        {
            key: 'supplierTag',
            label: 'Ярлыки поставщика',
            description: 'ID ярлыка поставщика.',
            valueType: 'id',
        },
        {
            key: 'supplierManager',
            label: 'Менеджер компании поставщика',
            description: 'ID менеджера компании поставщика.',
            valueType: 'id',
        },
        {
            key: 'creationDateFrom',
            label: 'Дата получения счёта',
            description: 'Начало периода даты получения счёта (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'creationDateTo',
            label: 'Дата получения счёта',
            description: 'Конец периода даты получения счёта (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'offerDateFrom',
            label: 'Дата счёта',
            description: 'Начало периода даты счёта (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'offerDateTo',
            label: 'Дата счёта',
            description: 'Конец периода даты счёта (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'paymentAmountFrom',
            label: 'Сумма платежа',
            description: 'Минимальная сумма платежа.',
            valueType: 'string',
        },
        {
            key: 'paymentAmountTo',
            label: 'Сумма платежа',
            description: 'Максимальная сумма платежа.',
            valueType: 'string',
        },
        {
            key: 'paymentDateFrom',
            label: 'Дата платежа',
            description: 'Начало периода даты платежа (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'paymentDateTo',
            label: 'Дата платежа',
            description: 'Конец периода даты платежа (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'lastAcceptedDateFrom',
            label: 'Дата принятия в оплату',
            description: 'Начало периода даты принятия в оплату (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'lastAcceptedDateTo',
            label: 'Дата принятия в оплату',
            description: 'Конец периода даты принятия в оплату (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'deliveryDateFrom',
            label: 'Дата доставки',
            description: 'Начало периода даты доставки (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'deliveryDateTo',
            label: 'Дата доставки',
            description: 'Конец периода даты доставки (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'acceptDateFrom',
            label: 'Дата согласования',
            description: 'Начало периода даты согласования (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'acceptDateTo',
            label: 'Дата согласования',
            description: 'Конец периода даты согласования (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'offerAmountFrom',
            label: 'Сумма счёта',
            description: 'Минимальная сумма счёта.',
            valueType: 'string',
        },
        {
            key: 'offerAmountTo',
            label: 'Сумма счёта',
            description: 'Максимальная сумма счёта.',
            valueType: 'string',
        },
        {
            key: 'offerDelayFrom',
            label: 'Отсрочка',
            description: 'Минимальная отсрочка в днях.',
            valueType: 'string',
        },
        {
            key: 'offerDelayTo',
            label: 'Отсрочка',
            description: 'Максимальная отсрочка в днях.',
            valueType: 'string',
        },
        {
            key: 'hasApprovedPayment',
            label: 'Есть платежи, принятые к оплате',
            description: 'Есть платежи, принятые к оплате (true).',
            valueType: 'boolean',
        },
        {
            key: 'hasUnApprovedPayment',
            label: 'Есть платежи, не принятые к оплате',
            description: 'Есть платежи, не принятые к оплате (true).',
            valueType: 'boolean',
        },
        {
            key: 'hasCompletedDeliveries',
            label: 'Есть выполненные доставки',
            description: 'Есть выполненные доставки (true).',
            valueType: 'boolean',
        },
        {
            key: 'hasDelivered',
            label: 'Счёт ещё не доставлен',
            description: 'false — счёт ещё не доставлен; true — есть доставка.',
            valueType: 'boolean',
        },
        {
            key: 'hasNotOriginals',
            label: 'Нет оригиналов документов',
            description: 'Нет оригиналов документов (true).',
            valueType: 'boolean',
        },
        {
            key: 'isApproved',
            label: 'Счёт подтверждён',
            description: 'Счёт подтверждён (true).',
            valueType: 'boolean',
        },
        {
            key: 'hasPayerNumber',
            label: 'Есть номер счёта покупателя',
            description: 'Есть номер счёта покупателя: true или false.',
            valueType: 'boolean',
        },
        {
            key: 'hasNoAcceptor',
            label: 'Нет акцептора',
            description: 'У счёта нет акцептора (true).',
            valueType: 'boolean',
        },
        {
            key: 'onlySimple',
            label: 'Только простые',
            description: 'Только простые счета (true).',
            valueType: 'boolean',
        },
        {
            key: 'isOverdue',
            label: 'Просроченные',
            description: 'Только просроченные счета (true).',
            valueType: 'boolean',
        },
        {
            key: 'only1C',
            label: 'Счета из 1С',
            description: 'Только счета из 1С (true).',
            valueType: 'boolean',
        },
        {
            key: 'orderBy',
            label: 'Сортировка',
            description:
                'Сортировка по возрастанию. Допустимые столбцы: id (ID), offer (Счёт), producer (Поставщик), payer (Плательщик), amount (Сумма).',
            valueType: 'enum',
            enumValues: ['id', 'offer', 'producer', 'payer', 'amount'],
        },
        {
            key: 'orderByDesc',
            label: 'Сортировка',
            description:
                'Сортировка по убыванию. Допустимые столбцы: id (ID), offer (Счёт), producer (Поставщик), payer (Плательщик), amount (Сумма).',
            valueType: 'enum',
            enumValues: ['id', 'offer', 'producer', 'payer', 'amount'],
        },
    ],
};
